const EXACT_TRANSLATIONS: Record<string, string> = {
  'Blockscout blockchain explorer': 'کاوشگر بلاکچین صبانفت',
  'Top accounts': 'حساب‌های برتر',
  Blocks: 'بلاک‌ها',
  'Latest blocks': 'آخرین بلاک‌ها',
  'View all blocks': 'مشاهده همه بلاک‌ها',
  Transactions: 'تراکنش‌ها',
  'Latest transactions': 'آخرین تراکنش‌ها',
  'Latest txn': 'آخرین تراکنش',
  'View all transactions': 'مشاهده همه تراکنش‌ها',
  'Internal transactions': 'تراکنش‌های داخلی',
  'User operations': 'عملیات کاربران',
  Operations: 'عملیات',
  'Verified contracts': 'قراردادهای تأییدشده',
  'Verify contract': 'تأیید قرارداد',
  'Name services lookup': 'جست‌وجوی سرویس نام',
  Validators: 'اعتبارسنج‌ها',
  Withdrawals: 'برداشت‌ها',
  Deposits: 'واریزها',
  Tokens: 'توکن‌ها',
  'Token transfers': 'انتقال‌های توکن',
  'Token Transfers': 'انتقال‌های توکن',
  'DEX tracker': 'رهگیری صرافی غیرمتمرکز',
  'Charts & stats': 'نمودارها و آمار',
  Other: 'سایر',
  Blockchain: 'بلاکچین',
  'Watch list': 'فهرست پیگیری',
  'Private tags': 'برچسب‌های خصوصی',
  'API keys': 'کلیدهای API',
  'Verified addrs': 'آدرس‌های تأییدشده',
  'Gas tracker': 'رهگیری کارمزد',
  'Total blocks': 'تعداد کل بلاک‌ها',
  'Average block time': 'میانگین زمان بلاک',
  'Total transactions': 'تعداد کل تراکنش‌ها',
  'Wallet addresses': 'آدرس‌های کیف پول',
  'Network utilization': 'استفاده از شبکه',
  'Daily transactions': 'تراکنش‌های روزانه',
  'Incomplete day': 'روز ناتمام',
  'Tx/day': 'تراکنش/روز',
  'Scanning new transactions...': 'در حال بررسی تراکنش‌های جدید...',
  'scanning new transactions...': 'در حال بررسی تراکنش‌های جدید...',
  Miner: 'تولیدکننده بلاک',
  Devnet: 'زنجیره صبا',
  'Search results': 'نتایج جست‌وجو',
  'View all results': 'مشاهده همه نتایج',
  'Recent searches': 'جست‌وجوهای اخیر',
  Clear: 'پاک کردن',
  Search: 'جست‌وجو',
  Filter: 'فیلتر',
  Apply: 'اعمال',
  Reset: 'بازنشانی',
  Export: 'خروجی',
  Download: 'دانلود',
  Copy: 'کپی',
  Copied: 'کپی شد',
  Settings: 'تنظیمات',
  'User settings': 'تنظیمات کاربر',
  Light: 'روشن',
  'Address format': 'قالب آدرس',
  Back: 'بازگشت',
  'Back to home': 'بازگشت به صفحه اصلی',
  Next: 'بعدی',
  Previous: 'قبلی',
  First: 'اول',
  Last: 'آخر',
  'Show more': 'نمایش بیشتر',
  'Show less': 'نمایش کمتر',
  Expand: 'باز کردن',
  Collapse: 'بستن',
  'View details': 'مشاهده جزئیات',
  Details: 'جزئیات',
  Overview: 'نمای کلی',
  Info: 'اطلاعات',
  'Additional info': 'اطلاعات تکمیلی',
  'Transaction details': 'جزئیات تراکنش',
  'Address details': 'جزئیات آدرس',
  'Contract details': 'جزئیات قرارداد',
  'Token details': 'جزئیات توکن',
  'Block details': 'جزئیات بلاک',
  Status: 'وضعیت',
  Success: 'موفق',
  Failed: 'ناموفق',
  Pending: 'در انتظار',
  Confirmed: 'تأییدشده',
  Error: 'خطا',
  Loading: 'در حال بارگذاری',
  'No data': 'داده‌ای وجود ندارد',
  'No results found': 'نتیجه‌ای پیدا نشد',
  'Page not found': 'صفحه پیدا نشد',
  Alert: 'هشدار',
  Method: 'متد',
  Type: 'نوع',
  From: 'از',
  To: 'به',
  Value: 'مقدار',
  Fee: 'کارمزد',
  'Txn fee': 'کارمزد تراکنش',
  'Transaction fee': 'کارمزد تراکنش',
  'Gas used': 'گس مصرف‌شده',
  'Gas limit': 'سقف گس',
  'Gas price': 'قیمت گس',
  'Base fee': 'کارمزد پایه',
  'Burnt fees': 'کارمزد سوزانده‌شده',
  Reward: 'پاداش',
  Nonce: 'نانس',
  Position: 'موقعیت',
  Timestamp: 'زمان ثبت',
  Age: 'زمان گذشته',
  Hash: 'هش',
  'Parent hash': 'هش والد',
  Block: 'بلاک',
  Txn: 'تراکنش',
  'Size, bytes': 'اندازه، بایت',
  Validator: 'اعتبارسنج',
  Address: 'آدرس',
  Contract: 'قرارداد',
  Creator: 'سازنده',
  Balance: 'موجودی',
  Balances: 'موجودی‌ها',
  Token: 'توکن',
  Name: 'نام',
  Symbol: 'نماد',
  Holder: 'دارنده',
  Holders: 'دارندگان',
  Quantity: 'تعداد',
  Percentage: 'درصد',
  'Total supply': 'عرضه کل',
  Transfers: 'انتقال‌ها',
  Inventory: 'دارایی‌ها',
  Logs: 'رویدادها',
  'State changes': 'تغییرات وضعیت',
  'Raw trace': 'ردیابی خام',
  'Read contract': 'خواندن قرارداد',
  'Write contract': 'نوشتن در قرارداد',
  Code: 'کد',
  Compiler: 'کامپایلر',
  Optimization: 'بهینه‌سازی',
  License: 'مجوز',
  'Add to MetaMask': 'افزودن به متامسک',
  'Add network': 'افزودن شبکه',
  'Connect wallet': 'اتصال کیف پول',
  Disconnect: 'قطع اتصال',
  Login: 'ورود',
  Logout: 'خروج',
  Testnet: 'زنجیره صبا',
  Mainnet: 'شبکه اصلی',
  'Smart contract': 'قرارداد هوشمند',
  'Contract verification': 'تأیید قرارداد',
  'Source code': 'کد منبع',
  'Read & write contract': 'خواندن و نوشتن قرارداد',
  Pagination: 'صفحه‌بندی',
  'Rows per page': 'تعداد ردیف در صفحه',
  Items: 'موارد',
  All: 'همه',
  Incoming: 'ورودی',
  Outgoing: 'خروجی',
  Self: 'داخلی',
  More: 'بیشتر',
  Less: 'کمتر',
  Close: 'بستن',
  Cancel: 'انصراف',
  Save: 'ذخیره',
  Submit: 'ثبت',
  Confirm: 'تأیید',
  Yes: 'بله',
  No: 'خیر',
  'N/A': 'ناموجود',
  Never: 'هرگز',
  Today: 'امروز',
  'No data. Please reload the page.': 'داده‌ای دریافت نشد. لطفاً صفحه را دوباره بارگذاری کنید.',
  'Oops! Something went wrong': 'خطایی رخ داد',
  'Access to this resource is restricted.': 'دسترسی به این منبع محدود شده است.',
  'Request cannot be processed': 'درخواست قابل پردازش نیست',
  Account: 'حساب',
  Active: 'فعال',
  'Add address': 'افزودن آدرس',
  'Add details': 'افزودن جزئیات',
  'Add email': 'افزودن ایمیل',
  'Add new tag': 'افزودن برچسب جدید',
  'Add private tag': 'افزودن برچسب خصوصی',
  'Add public tag': 'افزودن برچسب عمومی',
  'Add token info': 'افزودن اطلاعات توکن',
  'Advanced filter': 'فیلتر پیشرفته',
  After: 'بعد از',
  Amount: 'مقدار',
  Approved: 'تأییدشده',
  Array: 'آرایه',
  Asset: 'دارایی',
  'Associated address': 'آدرس مرتبط',
  Authority: 'مرجع',
  'Available soon': 'به‌زودی در دسترس',
  Before: 'قبل از',
  'Blob hash': 'هش Blob',
  'Block count': 'تعداد بلاک',
  'Block countdown': 'شمارش معکوس بلاک',
  'Block range': 'بازه بلاک',
  'Blocks count': 'تعداد بلاک‌ها',
  Category: 'دسته‌بندی',
  Chain: 'زنجیره',
  'Chain ID': 'شناسه زنجیره',
  Change: 'تغییر',
  'Clear all': 'پاک کردن همه',
  Columns: 'ستون‌ها',
  Commission: 'کمیسیون',
  Commitment: 'تعهد',
  'Connected wallet': 'کیف پول متصل',
  Disconnected: 'قطع‌شده',
  'Constructor args': 'آرگومان‌های سازنده',
  'Contract address': 'آدرس قرارداد',
  'Contract call': 'فراخوانی قرارداد',
  'Contract information': 'اطلاعات قرارداد',
  'Contract owner:': 'مالک قرارداد:',
  'Contract source code': 'کد منبع قرارداد',
  'Could not determine': 'قابل تشخیص نیست',
  'Could not find any matches.': 'موردی پیدا نشد.',
  Data: 'داده',
  'Data availability': 'دسترس‌پذیری داده',
  'Data type': 'نوع داده',
  Date: 'تاریخ',
  'Decode input data': 'رمزگشایی داده ورودی',
  'Decoded:': 'رمزگشایی‌شده:',
  'Delegated amount': 'مقدار واگذارشده',
  'Destination tx': 'تراکنش مقصد',
  Documentation: 'مستندات',
  Domain: 'دامنه',
  'Download CSV': 'دانلود CSV',
  'Election rewards': 'پاداش‌های انتخاباتی',
  Email: 'ایمیل',
  'Email notification': 'اعلان ایمیلی',
  'Estimated target date': 'تاریخ تخمینی هدف',
  'Expiration date': 'تاریخ انقضا',
  Expired: 'منقضی‌شده',
  Explorer: 'کاوشگر',
  'External call data': 'داده فراخوانی خارجی',
  'Failed to load some data. Please try again later.': 'بخشی از داده‌ها بارگذاری نشد. لطفاً بعداً دوباره تلاش کنید.',
  Field: 'فیلد',
  'Filtered by:': 'فیلترشده بر اساس:',
  'Finalized block': 'بلاک نهایی‌شده',
  Found: 'پیداشده',
  Gas: 'گس',
  'Gas price history': 'تاریخچه قیمت گس',
  Height: 'ارتفاع',
  'In progress': 'در حال انجام',
  'Incoming transfers': 'انتقال‌های ورودی',
  Index: 'شاخص',
  Key: 'کلید',
  Language: 'زبان',
  'Language / Compiler version': 'زبان / نسخه کامپایلر',
  'Last update': 'آخرین به‌روزرسانی',
  'Last updated': 'آخرین به‌روزرسانی',
  'Latest block': 'آخرین بلاک',
  Links: 'پیوندها',
  List: 'فهرست',
  'Log in': 'ورود',
  Message: 'پیام',
  Metadata: 'فراداده',
  Minted: 'ضرب‌شده',
  Modified: 'تغییریافته',
  'More details': 'جزئیات بیشتر',
  'More results': 'نتایج بیشتر',
  'My wallet': 'کیف پول من',
  'No data for visualization': 'داده‌ای برای نمایش وجود ندارد',
  'No recent data available': 'داده جدیدی در دسترس نیست',
  'No results found.': 'نتیجه‌ای پیدا نشد.',
  'No tokens found': 'توکنی پیدا نشد',
  'No trace entries found.': 'موردی در ردیابی پیدا نشد.',
  Notifications: 'اعلان‌ها',
  'On-chain market cap': 'ارزش بازار درون‌زنجیره‌ای',
  'Outgoing transfers': 'انتقال‌های خروجی',
  'Output root': 'ریشه خروجی',
  Owner: 'مالک',
  Payload: 'محموله',
  Period: 'دوره',
  Pool: 'استخر',
  Popular: 'محبوب',
  Price: 'قیمت',
  'Private tag': 'برچسب خصوصی',
  Proof: 'اثبات',
  Protocol: 'پروتکل',
  'Public tags': 'برچسب‌های عمومی',
  Rank: 'رتبه',
  'Raw:': 'خام:',
  'Read-only': 'فقط خواندنی',
  Receiver: 'گیرنده',
  Recent: 'اخیر',
  Rejected: 'ردشده',
  Reorg: 'بازسازمان‌دهی',
  'Request status': 'وضعیت درخواست',
  'Resolution age': 'زمان گذشته از حل',
  'Resolved to this address': 'حل‌شده به این آدرس',
  'Reward type': 'نوع پاداش',
  Sender: 'فرستنده',
  'Sending request': 'در حال ارسال درخواست',
  Signature: 'امضا',
  Signers: 'امضاکنندگان',
  Size: 'اندازه',
  Sort: 'مرتب‌سازی',
  'Source tx': 'تراکنش مبدأ',
  Storage: 'فضای ذخیره‌سازی',
  Tag: 'برچسب',
  Target: 'هدف',
  'There are no logs for this transaction.': 'برای این تراکنش رویدادی وجود ندارد.',
  'There are no transactions.': 'تراکنشی وجود ندارد.',
  'There is no data': 'داده‌ای وجود ندارد',
  'This blob is not yet indexed': 'این Blob هنوز ایندکس نشده است',
  'This is a testnet transaction only': 'این تراکنش متعلق به زنجیره صبا است',
  'Time left': 'زمان باقی‌مانده',
  'Token ID': 'شناسه توکن',
  'Token info': 'اطلاعات توکن',
  Topics: 'موضوع‌ها',
  Total: 'مجموع',
  'Transaction has been confirmed.': 'تراکنش تأیید شده است.',
  'Try again': 'تلاش دوباره',
  'Tx hash': 'هش تراکنش',
  'Txn count': 'تعداد تراکنش‌ها',
  'Txn hash': 'هش تراکنش',
  'Txn type:': 'نوع تراکنش:',
  Txs: 'تراکنش‌ها',
  'Txs count': 'تعداد تراکنش‌ها',
  Uncle: 'بلاک عمو',
  User: 'کاربر',
  'User op hash': 'هش عملیات کاربر',
  Verified: 'تأییدشده',
  'View all': 'مشاهده همه',
  'View transaction details': 'مشاهده جزئیات تراکنش',
  'Waiting for confirmation': 'در انتظار تأیید',
  'Waiting for update': 'در انتظار به‌روزرسانی',
};

const PATTERN_TRANSLATIONS: Array<[RegExp, string]> = [
  [ /Blockscout/gi, 'صبانفت' ],
  [ /Saba Chain blockchain explorer/gi, 'کاوشگر بلاکچین صبا' ],
  [ /Saba Chain explorer/gi, 'کاوشگر زنجیره صبا' ],
  [ /Saba Chain/gi, 'زنجیره صبا' ],
  [ /blockchain explorer/gi, 'کاوشگر بلاکچین' ],
  [ /\bverified contracts\b/gi, 'قراردادهای تأییدشده' ],
  [ /\binternal transactions\b/gi, 'تراکنش‌های داخلی' ],
  [ /\btoken transfers\b/gi, 'انتقال‌های توکن' ],
  [ /\btop accounts\b/gi, 'حساب‌های برتر' ],
  [ /\baddress details\b/gi, 'جزئیات آدرس' ],
  [ /\btoken details\b/gi, 'جزئیات توکن' ],
  [ /\bblock details\b/gi, 'جزئیات بلاک' ],
  [ /\bcontract verification\b/gi, 'تأیید قرارداد' ],
  [ /\bsearch results?\b/gi, 'نتایج جست‌وجو' ],
  [ /\btransactions\b/gi, 'تراکنش‌ها' ],
  [ /\btransaction\b/gi, 'تراکنش' ],
  [ /\bblocks\b/gi, 'بلاک‌ها' ],
  [ /\bblock\b/gi, 'بلاک' ],
  [ /\btokens\b/gi, 'توکن‌ها' ],
  [ /\btoken\b/gi, 'توکن' ],
  [ /\baddresses\b/gi, 'آدرس‌ها' ],
  [ /\baddress\b/gi, 'آدرس' ],
  [ /\bcontracts\b/gi, 'قراردادها' ],
  [ /\bcontract\b/gi, 'قرارداد' ],
  [ /\bvalidators\b/gi, 'اعتبارسنج‌ها' ],
  [ /\bvalidator\b/gi, 'اعتبارسنج' ],
  [ /\bstats\b/gi, 'آمار' ],
  [ /\bdetails\b/gi, 'جزئیات' ],
  [ /\bexplorer\b/gi, 'کاوشگر' ],
  [ /^Block #?(\d+)$/i, 'بلاک #$1' ],
  [ /^Transaction #?(.+)$/i, 'تراکنش $1' ],
  [ /^Txn #?(.+)$/i, 'تراکنش $1' ],
  [ /^(\d+) transactions?$/i, '$1 تراکنش' ],
  [ /^(\d+) blocks?$/i, '$1 بلاک' ],
  [ /^Page (\d+) of (\d+)$/i, 'صفحه $1 از $2' ],
  [ /^Showing (\d+)[–-](\d+) of (\d+)$/i, 'نمایش $1 تا $2 از $3' ],
  [ /^Search by /i, 'جست‌وجو بر اساس ' ],
  [ /^View all /i, 'مشاهده همه ' ],
];

export default function translateFa(value: string): string {
  const leadingWhitespace = value.match(/^\s*/)?.[0] ?? '';
  const trailingWhitespace = value.match(/\s*$/)?.[0] ?? '';
  const normalized = value.trim();

  if (!normalized) {
    return value;
  }

  const exact = EXACT_TRANSLATIONS[normalized];
  if (exact) {
    return `${ leadingWhitespace }${ exact }${ trailingWhitespace }`;
  }

  const translated = PATTERN_TRANSLATIONS.reduce(
    (result, [ pattern, replacement ]) => result.replace(pattern, replacement),
    normalized,
  );

  return `${ leadingWhitespace }${ translated }${ trailingWhitespace }`;
}
